import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding: 0 0.833rem;
`;